module.exports = __webpack_public_path__ + "img/Ciencias Sociales.a5b34763.png";